import { Configuration, LogLevel } from "@azure/msal-browser";
import endpointsConfig from "../endpoints.config";

const resolveKnownAuthorities = (): string[] => {
  if (endpointsConfig.msalAuthorityDomain)
    return [endpointsConfig.msalAuthorityDomain];
  try {
    return [new URL(endpointsConfig.msalAuthorityURL).hostname];
  } catch {
    return [];
  }
};

export const msalConfig: Configuration = {
  auth: {
    clientId: endpointsConfig.msalClientID,
    authority: endpointsConfig.msalAuthorityURL,
    knownAuthorities: resolveKnownAuthorities(),
    redirectUri: "/",
    postLogoutRedirectUri: "/login",
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage", // "sessionStorage" is also an option
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string,
        containsPii: boolean,
      ): void => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          case LogLevel.Info:
            // Uncomment the next line to enable info-level logging.
            // console.info(message)
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          default:
            break;
        }
      },
    },
  },
};
export const protectedResources = {
  apiRG: {
    endpoint: endpointsConfig.UserBaseUrl,
    scopes: {
      read: [endpointsConfig.msalReadScope],
      write: [endpointsConfig.msalWriteScope],
    },
  },
};
export const loginRequest = {
  scopes: [
    "openid",
    "offline_access",
    ...protectedResources.apiRG.scopes.read,
    ...protectedResources.apiRG.scopes.write,
  ].filter(Boolean),
  prompt: "login",
  extraQueryParameters: { prompt_kmsi: "0" },
};
